<div class="modal-header shadow-sm">
  <h6 class="modal-title">{{ title }}</h6>
  <button
    type="button"
    class="btn-close"
    aria-label="Close"
    [disabled]="loading"
    (click)="close()"
  ></button>
</div>

<div class="modal-body">
  <p class="text-muted small mb-2">
    Select a date and time range (maximum 31 days).
  </p>

  <div class="d-flex flex-wrap gap-2 mb-3">
    @for (pick of quickPicks; track pick.key) {
      <button
        type="button"
        class="btn btn-sm"
        [class.btn-primary]="activeQuickPick === pick.key"
        [class.btn-outline-primary]="activeQuickPick !== pick.key"
        [disabled]="loading"
        (click)="applyQuickPick(pick.key)"
      >
        {{ pick.label }}
      </button>
    }
  </div>

  <div class="row gx-3 mb-2">
    <div class="col-12 col-md-6 mb-2 mb-md-0">
      <label for="device-log-start" class="form-label small text-muted mb-1">
        Start date &amp; time
      </label>
      <input
        id="device-log-start"
        type="datetime-local"
        class="form-control"
        [(ngModel)]="startDateTime"
        [disabled]="loading"
        (ngModelChange)="onRangeInputChange()"
      />
    </div>
    <div class="col-12 col-md-6">
      <label for="device-log-end" class="form-label small text-muted mb-1">
        End date &amp; time
      </label>
      <input
        id="device-log-end"
        type="datetime-local"
        class="form-control"
        [(ngModel)]="endDateTime"
        [disabled]="loading"
        (ngModelChange)="onRangeInputChange()"
      />
    </div>
  </div>

  @if (rangeError) {
    <div class="alert alert-warning py-2 px-3 mb-0 mt-2 small" role="alert">
      {{ rangeError }}
    </div>
  }

  @if (emptyMessage) {
    <div class="alert alert-info py-2 px-3 mb-0 mt-2 small" role="alert">
      {{ emptyMessage }}
    </div>
  }

  @if (loading) {
    <div class="d-flex align-items-center gap-2 mt-3 text-muted small">
      <span class="spinner-grow spinner-grow-sm" role="status" aria-hidden="true"></span>
      Preparing device logs…
    </div>
  }
</div>

<div class="modal-footer justify-content-between pt-0">
  <button
    type="button"
    class="btn btn-gray-light"
    [disabled]="loading"
    (click)="close()"
  >
    Cancel
  </button>
  <button
    type="button"
    class="btn btn-primary"
    [disabled]="loading || !!rangeError || !startDateTime || !endDateTime"
    (click)="download()"
  >
    @if (loading) {
      <span class="spinner-grow spinner-grow-sm me-1" role="status" aria-hidden="true"></span>
    }
    Download
  </button>
</div>
